import { Icon } from "icons";
import { useTranslation } from "react-i18next";
import {
  cn,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "ui";

import { useAppMetadata } from "src/contexts/AppMetadataContext";

export function GlobalNavigationInfoBadge() {
  const { t } = useTranslation();
  const metadata = useAppMetadata();

  if (!metadata.versionCheck.shouldShowBadge) {
    return null;
  }

  function handleClick() {
    window.location.reload();
  }

  return (
    <div className="fixed bottom-4 right-4 z-100 animate-in slide-in-from-bottom-2 fade-in duration-300">
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <button
              onClick={handleClick}
              className={cn(
                "flex items-center justify-center rounded-full bg-blue-500 p-3 text-white shadow-lg",
                "hover:bg-blue-600 transition-colors duration-200",
                "focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2",
              )}
            >
              <Icon name="tabler-refresh" className="h-5 w-5" />
            </button>
          </TooltipTrigger>
          <TooltipContent>
            <p>{t("updateAvailable.badgeText")}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
}
